// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fa01fd5f","455":"178845d0","977":"5336ac30"}[chunkId] + ".chunk.js";
};